import React from "react";
import { AddLearningPath } from "../../components/ManagerPortal/InsertLP/AddLearningPath";
import { HeaderNavigation } from "../../components/Headers/GlobalHeader";
import { StickyFooter } from "../../components/Footers/GlobalFooter";
import { Box } from "grommet";

const AddLearningPathPage = () => {
  return (
    <Box fill="vertical" justify="between">
      <HeaderNavigation />
      <Box flex="grow" pad="medium">
        <AddLearningPath />
      </Box>
      <StickyFooter />
    </Box>
  );
};

export default AddLearningPathPage;
